import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Login from '../pages/Login/Login';
import Dashboard from '../pages/Dashboard/Dashboard';
import Veiculos from '../pages/Cadastros/Veiculos/Veiculos';
import Clientes from '../pages/Cadastros/Clientes/';
import Fornecedores from '../pages/Cadastros/Fornecedores/Fornecedores';
import ControleAlugueis from '../pages/Cadastros/ControleAlugueis/ControleAlugueis';
import Relatorios from '../pages/Cadastros/Relatorios/Relatorios';
import AnaliseVeiculos from '../pages/Cadastros/AnaliseVeiculos/AnaliseVeiculos';
import Instrucoes from '../pages/Cadastros/Instrucoes/Instrucoes';
import MeuPerfil from '../pages/MeuPerfil/MeuPerfil'; 
import Usuarios from '../pages/Cadastros/Usuarios/Usuarios'; 
import Promocoes from '../pages/Cadastros/Promocoes/Promocoes'; 
import Multas from '../pages/Cadastros/Multas/Multas';
import RelatoriosMultas from '../pages/Cadastros/Multas/RelatoriosMultas';
import Assinatura from '../pages/Assinatura/Assinatura'; 

//adicionar cliente
import ClientesNovo from '../pages/Cadastros/Clientes/Adicionar';
import ClientesEditar from '../pages/Cadastros/Clientes/Editar';
import ClientesVisualizar from '../pages/Cadastros/Clientes/Visualizar';

// promocoes
import PromocaoForm from '../pages/Cadastros/Promocoes/PromocaoForm';
import PromocaoVisualizar from '../pages/Cadastros/Promocoes/PromocaoVisualizar';
import AluguelForm from '../pages/Cadastros/ControleAlugueis/AluguelForm';
import EditarAluguelForm from '../pages/Cadastros/ControleAlugueis/EditarAluguelForm';
import VisualizarAluguel from '../pages/Cadastros/ControleAlugueis/VisualizarAluguel';
import Frota from '../pages/Cadastros/Frotas/Frotas';
import Manutencoes from '../pages/Cadastros/Manutencoes/Manutencoes';
import Contratos from '../pages/Cadastros/Contratos/Contratos';
import ContratoAssinatura from '../pages/ContratoAssinatura/ContratoAssinatura';
import Integracoes from '../pages/Integracoes/Integracoes';
import WhatsAppBaileys from '../pages/WhatsApp/WhatsAppBaileys';
import CalendarioReservas from '../pages/Calendario/CalendarioReservas';
import PreReservas from '../pages/PreReservas/PreReservas';
import ReservaPublica from '../pages/Reservas/ReservaPublica';
import Arquivos from '../pages/Arquivos/Arquivos';


import Caixa from '../pages/Cadastros/Caixa/index';
import ContasPagar from '../pages/Cadastros/ContasPagar/index';
import ContasReceber from '../pages/Cadastros/ContasReceber/index';
import RelatoriosFinanceiros from '../pages/Financeiro/Relatorios';
import Configuracoes from '../pages/Configuracoes/Configuracoes';
import FichaCliente from '../pages/Controle/FichaCliente/FichaCliente';
import Vistorias from '../pages/Vistorias';
import VistoriaDetalhes from '../pages/VistoriaDetalhes';
import VistoriaAluguel from '../pages/VistoriaAluguel';
import VistoriaMobile from '../pages/VistoriaMobile';




export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/meu-perfil" element={<MeuPerfil />} />
      <Route path="/cadastros/usuarios" element={<Usuarios />} />

      <Route path="/cadastros/veiculos" element={<Veiculos />} />

      <Route path="/cadastros/clientes" element={<Clientes />} />
      <Route path="/cadastros/clientes/novo" element={<ClientesNovo />} />
<Route path="/cadastros/clientes/:uuid/editar" element={<ClientesEditar />} />
<Route path="/cadastros/clientes/:uuid/visualizar" element={<ClientesVisualizar />} />

      <Route path="/cadastros/promocoes" element={<Promocoes />} />
<Route path="/promocoes/nova" element={<PromocaoForm />} />
<Route path="/promocoes/:id/editar" element={<PromocaoForm />} />
<Route path="/promocoes/:id/visualizar" element={<PromocaoVisualizar />} />
  <Route path="/cadastros/caixa" element={<Caixa />} />
  <Route path="/cadastros/contaspagar" element={<ContasPagar />} />
  <Route path="/cadastros/contasreceber" element={<ContasReceber />} />
  <Route path="/cadastros/relatorios" element={<RelatoriosFinanceiros />} />

<Route path="/alugueis" element={<ControleAlugueis />} />
<Route path="/frotas" element={<Frota />} />
<Route path="/frotas/manutencoes" element={<Manutencoes />} />
<Route path="/contratos" element={<Contratos />} />
<Route path="/contratos/assinar/:token" element={<ContratoAssinatura />} />

<Route path="/alugueis/nova" element={<AluguelForm />} />
<Route
  path="/alugueis/:id/editar"
  element={<EditarAluguelForm key={window.location.pathname} />}
/>

<Route
  path="/alugueis/:id"
  element={<VisualizarAluguel key={window.location.pathname} />}
/>




      <Route path="/cadastros/fornecedores" element={<Fornecedores />} />
      <Route path="/relatorios" element={<Relatorios />} />
      <Route path="/analise-veiculos" element={<AnaliseVeiculos />} />
      <Route path="/integracoes" element={<Integracoes />} />
      <Route path="/whatsapp" element={<WhatsAppBaileys />} />
      <Route path="/calendario" element={<CalendarioReservas />} />
      <Route path="/multas" element={<Multas />} />
      <Route path="/multas/relatorios" element={<RelatoriosMultas />} />
      <Route path="/instrucoes" element={<Instrucoes />} />
      <Route path="/assinatura" element={<Assinatura />} />
      <Route path="/configuracoes" element={<Configuracoes />} />
      <Route path="/pre-reservas" element={<PreReservas />} />
      <Route path="/reservar" element={<ReservaPublica />} />
      <Route path="/controle/ficha-cliente" element={<FichaCliente />} />
      <Route path="/arquivos" element={<Arquivos />} />
      <Route path="/vistorias" element={<Vistorias />} />
      <Route path="/vistorias/:id" element={<VistoriaDetalhes />} />
      <Route path="/aluguel/:id/vistoria" element={<VistoriaAluguel />} />
      <Route path="/aluguel/:id/vistoria-mobile" element={<VistoriaMobile />} />
    </Routes>
  );
}
